export default "__VITE_ASSET__DFVhO3tC__"